/**
 * Ids that appeared in the list since the previous render, restricted to rows currently rendered.
 *
 * The visibility restriction is the point: in a virtualised list a row mounts whenever it scrolls
 * into the window, and treating that as "new" would fade every row in as the user scrolls.
 */
export const diffEnteringIds = (
    previousIds: ReadonlySet<string> | undefined,
    currentIds: readonly string[],
    visibleIndexes: ReadonlySet<number>,
): readonly string[] => {
    if (!previousIds) {
        return [];
    }

    return currentIds.filter((id, index) => !previousIds.has(id) && visibleIndexes.has(index));
};
